import { Trans } from 'react-i18next';
import { Button, Icon, message } from 'ui';
import { copyToClipboard } from 'features/copy-to-clipboard';
import { useGetInvitationTokenMutation } from 'features/invitation-tokens';
import { useGenerateInvitationLink, useGetInvitationTokenKind } from '../hooks';

type CopyInvitationLinkButtonProperties = {
  eventId: string;
  linkType: InvitationLinkType;
};

type InvitationLinkType = 'attendee' | 'presenter';

const getInvitationLinkTranslationKey = (linkType: InvitationLinkType) => {
  switch (linkType) {
    case 'attendee':
      return 'Copy link for attendee';
    case 'presenter':
      return 'Copy link for presenter';
  }
};

const CopyInvitationLinkButton = ({ eventId, linkType }: CopyInvitationLinkButtonProperties) => {
  const { isPending, mutateAsync: createInvitationToken } = useGetInvitationTokenMutation();
  const generateInvitationLink = useGenerateInvitationLink();
  const getInvitationTokenKind = useGetInvitationTokenKind();

  const copyLink = async () => {
    await copyToClipboard(async () => {
      const { token } = await createInvitationToken({
        kind: getInvitationTokenKind({ type: linkType }),
        subjectId: eventId,
        subjectType: 'Event',
      });

      return generateInvitationLink({ eventId, token });
    });

    message.success('Link copied to clipboard');
  };

  return (
    <Button
      block
      icon={<Icon icon="link-line" />}
      loading={isPending}
      onClick={async () => {
        await copyLink();
      }}
      type="secondary"
    >
      <span>
        <Trans components={{ strong: <strong /> }} i18nKey={getInvitationLinkTranslationKey(linkType)} />
      </span>
    </Button>
  );
};

export default CopyInvitationLinkButton;
